module.exports = __webpack_public_path__ + "static/media/ic-openModeWhite.7cc2ae37.svg";